import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import EmailVerifiedIcon from './email-verified.svg';

const useStyles = makeStyles(() => ({
  successIcon: {
    marginBottom: 15,
  },
  successTitle: {
    fontSize: 27,
    fontWeight: 600,
    marginBottom: 18,
    lineHeight: 1.4,
  },
  okayButton: {
    backgroundColor: '#01619B',
    color: 'white',
    borderRadius: 8,
    height: 48,
    minWidth: 180,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#01619B',
    },
  },
}));

const VerificationSuccess = ({ title, buttonLabel, onOkay }) => {
  const classes = useStyles();

  return (
    <>
      <img
        src={EmailVerifiedIcon}
        className={classes.successIcon}
        alt="Email Verified"
      />
      <Typography className={classes.successTitle}>{title}</Typography>
      <Button
        variant="contained"
        className={classes.okayButton}
        onClick={onOkay}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

VerificationSuccess.propTypes = {
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onOkay: PropTypes.func.isRequired,
};

export default VerificationSuccess;
